import update from 'react-addons-update';
import { infraStructureConstants } from '../constants';

const initialState = {
	loading: false,
	paging: {},
	infraStructures: [],
	newInfraStructure: {
		type: '',
		body: {
			name: ''
		}
	},
	postInfrastructure: {
		loading: false
	},
	loadingAssociations: false,
	newAssociations: [],
	defaultAssociations: [],
	infraDetails: {
		loading: false,
		details: {}
	},
	filters: {
		types: ['local', 'occupationArea', 'businessUnit']
	},
	locals: [],
	occupationAreas: []
}

export function infraStructure(state = initialState, action) {
	switch (action.type) {
		case infraStructureConstants.REQUEST_INFRASTRUCTURE:
			return update(state, { loading: { $set: true } });

		case infraStructureConstants.FAILURE_INFRASTRUCTURE:
			return update(state, { loading: { $set: false } });

		case infraStructureConstants.GET_INFRASTRUCTURE:
			return update(state, {
				loading: { $set: false },
				paging: { $set: action.payload.paging },
				infraStructures: {
					$set: action.payload.infras
				}
			});

		case infraStructureConstants.DELETE_INFRASTRUCTURE:
			const filteredInfra = state.infraStructures.filter(({ id }) => id !== action.payload.id);
			return (update(state, {
				infraStructures: { $set: filteredInfra },
			}));

		case infraStructureConstants.SET_NEW_INFRASTRUCTURE:
			return (update(state, {
				newInfraStructure: {
					type: { $set: action.payload.type !== '' ? action.payload.type : state.newInfraStructure.type },
					body: {
						name: {
							$set: action.payload.name !== '' ? action.payload.name : state.newInfraStructure.body.name
						}
					}
				}
			}));

		case infraStructureConstants.REQUEST_POST_INFRASTRUCTURE:
			return (update(state, {
				postInfrastructure: {
					loading: { $set: true }
				}
			}));

		case infraStructureConstants.FAILURE_POST_INFRASTRUCTURE:
			return (update(state, {
				postInfrastructure: {
					loading: { $set: false }
				}
			}));

		case infraStructureConstants.POST_INFRASTRUCTURE:
			return (update(state, {
				postInfrastructure: {
					loading: { $set: false }
				}
			}));

		case infraStructureConstants.SET_NEW_ASSOCIATION:
			return (update(state, {
				newAssociations: { $push: [{
					businessUnit: action.payload.businessUnit,
					local: action.payload.local,
					occupationArea: action.payload.occupationArea,
					associationId: action.payload.associationId
				}]}
			}));

		case infraStructureConstants.SET_UNIQUE_NEW_ASSOCIATION:
			const associationIndex = state.newAssociations.map(({ associationId }) => associationId).indexOf(action.payload.associationId);
			state.newAssociations[associationIndex][action.payload.type] = action.payload.infra;
			return (update(state, {
				newAssociations: { $set: state.newAssociations }
			}));

	case infraStructureConstants.REQUEST_DEFAULT_ASSOCIATIONS:
			return (update(state, {
				loadingAssociations: { $set: true }
			}));

		case infraStructureConstants.SET_DEFAULT_ASSOCIATIONS:
			return (update(state, {
				defaultAssociations: { $push: [{
					businessUnit: action.payload.businessUnit,
					local: action.payload.local,
					occupationArea: action.payload.occupationArea,
					associationId: action.payload.associationId
				}]}
			}));

		case infraStructureConstants.GET_ASSOCIATIONS_SUCCESS:
			return (update(state, { loadingAssociations: { $set: false } }));

		case infraStructureConstants.REQUEST_PUT_INFRASTRUCTURE:
			return (update(state, {
				loading: { $set: true }
			}));

		case infraStructureConstants.FAILURE_PUT_INFRASTRUCTURE:
			return (update(state, {
				loading: { $set: false }
			}));


		case infraStructureConstants.PUT_INFRASTRUCTURE:
			const infraToEdit = state.infraStructures.filter(({ id }) => id === action.payload.id);
			const infraEdited = { ...infraToEdit[0], name: action.payload.name };
			const infrasFilter = state.infraStructures.filter(({ id }) => id !== action.payload.id);
			const infras = [...infrasFilter, infraEdited];
			return (update(state, {
				loading: { $set: false },
				infraStructures: { $set: infras }
			}));

		case infraStructureConstants.SET_PAGING:
			return (update(state, {
				paging: {
					[action.payload.type]: { $set: action.payload.value }
				}
			}));

		case infraStructureConstants.CLEAR_NEW_INFRASTRUCTURE:
			return (update(state, { newInfraStructure: { $set: initialState.newInfraStructure } }));

		case infraStructureConstants.CLEAR_INFRASTRUCTURES:
			return (update(state, { infraStructures: { $set: [] } }));

		case infraStructureConstants.CLEAR_ASSOCIATIONS:
			return(update(state, {
				defaultAssociations: {$set: []},
				newAssociations: {$set: []},
				associationsToUpdate: {$set: []}
			}));

		case infraStructureConstants.SET_ASSOCIATIONS_TO_UPDATE:
			const index = state.defaultAssociations.map(({ associationId }) => associationId).indexOf(action.payload.associationId);
			state.defaultAssociations[index][action.payload.type] = action.payload.infra;
			state.defaultAssociations[index]['isUpdate'] = true;

			return (update(state, {
				defaultAssociations: { $set: state.defaultAssociations }
			}));

		case infraStructureConstants.CLEAR:
			return (update(state, { $set: initialState }));

		case infraStructureConstants.REQUEST_SET_DETAILS:
			return (update(state, {
				infraDetails: { loading: { $set: true } }
			}));

		case infraStructureConstants.SET_DETAILS:
			return (update(state, {
				infraDetails: { loading: { $set: false }, details: { $set: action.payload } }
			}));

		case infraStructureConstants.FAILURE_SET_DETAILS:
			return (update(state, {
				infraDetails: { loading: { $set: false } }
			}));

		case infraStructureConstants.SET_FILTERS:
			return (update(state, {
				filters: {
					types: { $set: action.payload }
				}
			}));

		case infraStructureConstants.GET_LOCALS:
			return (update(state, {
				locals: {
					$set: action.payload
				}
			}));

		case infraStructureConstants.GET_OCCUPATION_AREA:
			return (update(state, {
				occupationAreas: {
					$set: action.payload
				}
			}));

		case infraStructureConstants.DELETE_DEFAULT_ASSOCIATION_SUCCESS:
			const defaultassociations = state.defaultAssociations.filter(({ associationId }) => associationId !== action.id);
			return(update(state, {
				defaultAssociations: { $set: defaultassociations }
			}));

		case infraStructureConstants.DELETE_NEW_ASSOCIATION_SUCCESS:
			const newassociations = state.newAssociations.filter(({ associationId }) => associationId !== action.id);
			return(update(state, {
				newAssociations: { $set: newassociations }
			}));

		default:
			return state;
	};
};
